import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { VariantSelectFragmentDoc } from '../fragments/variant.generated';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantCreateMutationVariables = Types.Exact<{
  input: Types.CreateVariantInput;
}>;

export type VariantCreateMutationResponse = {
  variantCreate?: Types.Maybe<
    Pick<
      Types.Variant,
      | 'id'
      | 'isOrigin'
      | 'isWinner'
      | 'trafficRate'
      | 'themePageID'
      | 'templateType'
      | 'templateSuffix'
      | 'createdAt'
      | 'deletedAt'
      | 'updatedAt'
      | 'winnerTemplateSuffix'
    >
  >;
};

export const VariantCreateDocument = `
    mutation VariantCreate($input: CreateVariantInput!) {
  variantCreate(input: $input) {
    ...VariantSelect
  }
}
    ${VariantSelectFragmentDoc}`;

export const useVariantCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantCreateMutationResponse,
    TError,
    VariantCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantCreateMutationResponse,
    TError,
    VariantCreateMutationVariables,
    TContext
  >(
    ['VariantCreate'],
    (variables?: VariantCreateMutationVariables) =>
      appFetcher<VariantCreateMutationResponse, VariantCreateMutationVariables>(
        VariantCreateDocument,
        variables,
      )(),
    options,
  );
};

useVariantCreateMutation.getKey = () => ['VariantCreate'];
